import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '@optsolservices/ngx-notification';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-pos-operator-transactions-report-dialog',
  templateUrl: './pos-operator-transactions-report-dialog.component.html',
  styleUrls: ['./pos-operator-transactions-report-dialog.component.scss']
})
export class PosOperatorTransactionsReportDialogComponent implements OnInit {
  form: FormGroup;
  stores: any[];
  reportConfig: any;

  constructor(
    public dialogRef: MatDialogRef<PosOperatorTransactionsReportDialogComponent>,
    private fb: FormBuilder,
    private baseService: BaseService,
    private notificationService: NotificationService,
  ) {
    const today = new Date();
    this.form = fb.group({
      storeId: [null, Validators.compose([Validators.required])],
      eodDate: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_money_container_batch_eod_operator_report_dialog_config', { "test": 1 })
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.stores = response.data.stores;
          this.reportConfig = response.data.reportConfig;
        } else {
          this.dialogRef.close();
        }
      });
  }

  save() {
    this.baseService.generateReport({ reportConfig: this.reportConfig, reportParameters: this.form.value });
    setTimeout(() => {
      this.dialogRef.close();
    }, 200);
  }

}
